import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from 'utils/numberFormatter';
import { RowItems } from '../../../../../models/TableProps';
import { QuotationSummariesTableItem } from '../../../../../models/quotations/Quotation';
import { TableCellWrapper } from '../../../../quotation-editor/shared/TableCellWrapper';

export const QuotationSummariesTableRow: React.FC<
    RowItems<QuotationSummariesTableItem>
> = (props) => {
    const { row } = props;
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.SUMMARY.PRODUCTS',
    });

    return (
        <TableRow hover>
            <TableCellWrapper type={'name'}>
                {row.tax != 0 ? '' : t('SUM')}
            </TableCellWrapper>
            <TableCellWrapper>
                {formatPrice(row.net_total)}&nbsp;Ft
            </TableCellWrapper>
            <TableCellWrapper>
                {row.tax != 0 ? row.tax + '%' : ''}
            </TableCellWrapper>
            <TableCellWrapper>
                {formatPrice(row.gross_total)}&nbsp;Ft
            </TableCellWrapper>
        </TableRow>
    );
};
